import { configureStore } from "@reduxjs/toolkit";
import undoable, { type StateWithHistory } from "redux-undo";
import slideEditorReducer, { type SlideEditorState } from "./slideEditorSlice";
import uiReducer, { type UiState } from "./uiSlice";

/**
 * Redux store configuration
 */
export const store = configureStore({
  reducer: {
    // Wrap slide editor with undo/redo functionality
    slideEditor: undoable(slideEditorReducer, {
      limit: 50, // Keep last 50 states for undo/redo
      filter: (action) => {
        // Don't track selection / transient-UI changes in undo/redo history
        return (
          action.type !== "slideEditor/setSelectedId" &&
          action.type !== "slideEditor/setFillBlanksActiveBlank"
        );
      },
    }),
    ui: uiReducer,
  },
});

// Infer types from the store itself
export type RootState = {
  slideEditor: StateWithHistory<SlideEditorState>;
  ui: UiState;
};
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
